export default __webpack_public_path__ + "static/media/centro.283b705e.jpg";